import React from 'react';

import {ClockLoader} from '@components/ClockLoader';
interface LoadingErrorHandlerProps {
  isLoading: boolean;
  isError: boolean;
  error?: unknown;
  children: React.ReactNode;
}

export function LoadingErrorHandler({ 
  isLoading, 
  isError, 
  children 
}: LoadingErrorHandlerProps) {
  
  if (isError) {
    return <div>Error occurred</div>;
  }

  if (isLoading) {
    return <ClockLoader/>;
  }

  return <>{children}</>;
}